export default __webpack_public_path__ + "static/media/bgone.2cb617bb.jpg";